import { getUsers } from "data/apiConection.js/dataUsers";

export const dashboardRoutes = {
  label: 'Inicio',
  labelDisable: true,
  children: [
    {
      name: 'Inicio',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Inicio',
          to: '/',
          active: true
        }
      ]
    }
  ]
};
export const dashboardPadres = {
  label: 'Inicio',
  labelDisable: true,
  children: [
    {
      name: 'Cuotas',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Cuotas',
          to: '/estados-cuentas',
          active: true
        }
      ]
    }
  ]
}
export const appRoutes = {
  label: 'Finanazas',
  children: [
    {
      name: 'Datos',
      icon: 'chart-pie',
      active: true,
      children: [
       {
          name: 'Reportes',
          to: '/reportes',
          active: true
        },
        {
          name: 'Descuentos',
          to: '/alumnos/cuotas',
          active: true,
        },
        {
          name: 'Cuotas 2025',
          to: '/alumnos/cuotas/meses-all',
          active: true,
        }]
    },{
      
    }
  , {
      name: 'Meses',
      icon: 'chart-pie',
      active: true,
      children: [
        {
          name: 'Marzo',
          to: '/alumnos/cuotas/marzo',
          active: true,
        }
        ,
        {
          name: 'Abril',
          to: '/alumnos/cuotas/abril',
          active: true,
        }        ,
        {
          name: 'Mayo',
          to: '/alumnos/cuotas/mayo',
          active: true,
        },
        {
          name: 'Junio',
          to: '/alumnos/cuotas/junio',
          active: true,
        },
        {
          name: 'Julio',
          to: '/alumnos/cuotas/julio',
          active: true
        }
       ]
    },{
      
    }]
};

export const alumnosRoutes = {
  label: 'Estudiantes',
  children: [
    {
      name: 'Alumnos',
      icon: 'user',
      active: true,
      children: [
        {
          name: 'Ciclo-2024',
          to: '/alumnos/lista-a/:id',
          active: true
        },
        {
          name: 'Ciclo-2025',
          to: '/alumnos/lista-2025',
          active: true
        },
        {
          name: 'Nuevo',
          to: '/alumnos/nuevo',
          active: true
        }
      ]
    }
  ]
};
export const alumnosRoutesForTeacher = {
  label: 'Estudiantes',
  children: [
    {
      name: 'Alumnos',
      icon: 'user',
      active: true,
      children: [
        {
          name: 'Exámenes',
          to: '/alumnos/lista/:id',
          active: true
        }
      ]
    }
  ]
};

export const cursosRoutes = {
  label: 'Cursos',
  children: [
    {
      name: 'Cursos',
      icon: 'user',
      active: true,
      children: [
        {
          name: 'Lista',
          to: '/cursos/lista',
          active: true
        },
        {
          name: 'Nuevo',
          to: '/cursos/nuevo',
          active: true,
        }
      ]
    }
  ]
}
export const profesoresRoutes = {
  label: 'Profesores',
  children: [
    {
      name: 'Profesores',
      icon: 'user',
      active: true,
      children : [
        {
          name: 'Lista',
          to: '/profesores/lista',
          active: true,
        },
        {
          name: 'Nuevo',
          to:'/profesores/nuevo',
          active: true,
        }
      ]
    }
  ]
}
export const usuariosRoutes = {
  label: 'Usuarios',
  children: [
    {
      name: 'Usuarios',
      icon: 'user',
      active: true,
      children : [
        {
          name: 'Nuevo',
          to:'/users/nuevo',
          active: true,
        },
        {
          name: 'Lista',
          to: '/users/lista',
          active: true,
        }
      ]
    }
  ]
};
export const routesByRole = async (role) => {
  switch (role) {
    case 'manager':
      return [
        dashboardRoutes,
        appRoutes,
        alumnosRoutes,
        cursosRoutes,
        profesoresRoutes,
        usuariosRoutes,
      ];
    case 'teacher':
      return [
        alumnosRoutesForTeacher,
      ];
    case 'admin':
      return [
        dashboardRoutes,
        appRoutes,
        alumnosRoutes,
        cursosRoutes,
        profesoresRoutes
      ];
    default:
      return [
        alumnosRoutes,
      ];
  }
};

const getRoutes = async () => {
  const user = await getUsers();
  const userRole = user?.role || ''; // Fallback si user.role es null o undefined
  console.log(userRole);
  return routesByRole(userRole);
};
export default getRoutes;



